var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientFileManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.714V10M5 8.714C4.45643 8.71781 3.92006 8.58968 3.4369 8.34061C2.95374 8.09154 2.53822 7.72897 2.226 7.284M5 8.714C5.54357 8.71781 6.07994 8.58868 6.5631 8.33961C7.04626 8.09054 7.46178 7.72797 7.774 7.283M5 2.285C6.157 2.285 7.176 2.853 7.774 3.715M2.226 3.717C2.53822 3.27203 2.95374 2.90946 3.4369 2.66039C3.92006 2.41132 4.45643 2.28319 5 2.287V1M2.226 3.717L1 2.93M2.226 3.717C1.86165 4.24019 1.66633 4.86244 1.66633 5.5C1.66633 6.13756 1.86165 6.75981 2.226 7.283M9 2.929L7.774 3.717C8.13835 4.24019 8.33367 4.86144 8.33367 5.499C8.33367 6.13656 8.13835 6.75881 7.774 7.282L9 8.07M1 8.07L2.226 7.282",
    stroke: "#1356FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1H11.273C14.533 1 16.165 1 17.297 1.798C17.621 2.026 17.909 2.298 18.152 2.603C19 3.669 19 5.203 19 8.273V10.818C19 13.781 19 15.263 18.531 16.446C17.777 18.349 16.183 19.849 14.161 20.559C12.904 21 11.331 21 8.181 21C6.383 21 5.483 21 4.765 20.748C3.61 20.342 2.699 19.485 2.268 18.398C2 17.722 2 16.875 2 15.182V12",
    stroke: "#1356FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19 11.884 18.6488 12.7317 18.0238 13.3568C17.3987 13.9818 16.551 14.333 15.667 14.333C15.001 14.333 14.216 14.217 13.569 14.39C13.2864 14.466 13.0288 14.6149 12.8218 14.8218C12.6149 15.0288 12.466 15.2864 12.39 15.569C12.217 16.216 12.333 17.001 12.333 17.667C12.333 18.1047 12.2468 18.5381 12.0793 18.9425C11.9118 19.3469 11.6663 19.7143 11.3568 20.0238C11.0473 20.3333 10.6799 20.5788 10.2755 20.7463C9.87111 20.9138 9.4377 21 9 21",
    stroke: "#1356FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientFileManagementIcon);
export default __webpack_public_path__ + "static/media/patient_file_management_icon.39b254b3c3f67a2a03f2f0b1fbf456bb.svg";
export { ForwardRef as ReactComponent };